module.exports = __webpack_public_path__ + "img/work_parked.71670570.svg";